$(document).on("click", 'a[href="#"]', function (e) {
 e.preventDefault(); 
next_step();
});
$(document).on("click", '.quiz_question_list:not(.quiz_question_list12) .icons_with_text_flex', function (e) {
 e.preventDefault(); 
 $(this).parents('.quiz_question_list').find('.icons_with_text_flex').removeClass('active');
 $(this).parents('.quiz_step').find('.quiz_question_above').removeClass('active');
 $(this).addClass('active');
next_step();
});


$(document).on("click", '.quiz_question_list.quiz_question_list12 .icons_with_text_flex', function (e) {
 e.preventDefault(); 
 $(this).parents('.quiz_step').find('.quiz_question_above').removeClass('active');
 $(this).addClass('active');
});
$(document).on("click", '.quiz_question_above', function (e) {
 e.preventDefault(); 
 $(this).parents('.quiz_step').find('.icons_with_text_flex').removeClass('active');
 $(this).addClass('active');
});

$(document).on("click", '.quiz_previous_question .icons_with_text_item', function (e) {
 e.preventDefault(); 
prev_step();
});

$(document).on("click", 'a[href="#reviews"]', function (e) {
 e.preventDefault(); 
});
function next_step() {

  var loader = $('main#MainContent');
  var current_slide = $('.quiz_step.active').closest('.shopify-section');
  var next_slide = current_slide.next('.shopify-section');

  loader.addClass('loading_hk');

  if (!next_slide.length) {

    setTimeout(function () {
      window.location.href = "/products/face-system?view=face_system_quiz"; // ← change link
    }, 1500);

    return;
  }


  setTimeout(function () {
    loader.removeClass('loading_hk');
  current_slide.find('.quiz_step').removeClass('active');
  var activeStep = next_slide.find('.quiz_step').addClass('active');
updateQuizProgress();
if(activeStep.find('.list13_svg_1').length){
  runQuizIconAnimation(activeStep);
}
  }, 700);
}


function prev_step() {
  var loader = $('main#MainContent');
  var current_slide = $('.quiz_step.active').closest('.shopify-section');
  var next_slide = current_slide.prev('.shopify-section');

  loader.addClass('loading_hk');
  setTimeout(function () {
    loader.removeClass('loading_hk');
  current_slide.find('.quiz_step').removeClass('active');
  next_slide.find('.quiz_step').addClass('active');
updateQuizProgress();
  }, 300);
}



function runQuizIconAnimation(step){

  var svg1 = step.find('.list13_svg_1');
  var svg2 = step.find('.list13_svg_2');

  svg2.hide();

  svg1.css('animation','rotateCircle 3s linear infinite');

  setTimeout(function(){

    svg1.hide();
    svg2.show();

    setTimeout(function(){
      next_step();
    },2000);

  },3000);

}


function updateQuizProgress(){

  var steps = $('.quiz_step');
  var totalSteps = steps.length;

  var activeIndex = steps.index($('.quiz_step.active'));

  var progress = (activeIndex / (totalSteps - 1)) * 100;

  $('.animation_bar_fill').css('width', progress + '%');

}